<!-- 
    通用定位组件(参数type:资源类型（资源类型就是在五个一控制台配置图层时选择的类型）,objid:资源的对象ID)
    mode:模式:web/h5，在显示上有所区别，例如h5里面不显示zoom控件
-->
<template>
  <div class="dhmap-wrapper">
    <div id="locatemap" ref="locatemap" v-resize="resize"></div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import "ol/ol.css";
import {
  initMap,
  addLayerToMap,
  addLocateLayerToMap,
  actLocate,
  mapalert,
} from "@/utils/MapUtils";

export default {
  name: "map-locator",
  components: {},
  props: {
    param: {
      type: Object,
      default: () => {
        return {};
      },
    },
    mode: { type: String, default: "web" },
  },
  data() {
    return {
      map: null,
      zqCode: "",
      gisconfig: {},
    };
  },
  mounted() {
    this.zqCode = this.$route.query.zqCode;
    this.loadMap();
  },
  methods: {
    loadMap() {
      var _this = this;
      this.$api.Mapapi.getconfig({
        appId: "shushan",
      })
        .then((res) => {
          if (res && res.code == 1) {
            console.log(res.data);
            _this.gisconfig = res.data;
            //设置该地图根据CQL进行过滤加载
            _this.gisconfig.queryWithCQL = true;
            //设置CQL进行查询，必须要提供uid、uregion、uregionlevel三个参数
            _this.gisconfig.uid = "";
            _this.gisconfig.uregion = _this.zqCode;

            _this.gisconfig.uregionlevel = [
              null,
              1,
              1,
              2,
              2,
              3,
              3,
              4,
              4,
              4,
              5,
              5,
              5,
              5,
              5,
            ][_this.gisconfig.uregion.length];

            console.log(_this.gisconfig);
            //初始化地图
            if (this.mode == "h5") {
              _this.map = initMap("locatemap", _this.gisconfig, {
                showZoom: false,
              });
            } else {
              _this.map = initMap("locatemap", _this.gisconfig);
            }
            _this.map.gisConfig = res.data;
            //添加图层
            addLayerToMap(_this.map, _this.gisconfig, null, [
              "geo_sheng",
              "geo_shi",
              "geo_xian",
              "geo_xiang",
              "geo_cun",
            ]);
            addLocateLayerToMap(_this.map);
            //调用MapUtil添加图层
            actLocate(_this.map, _this.param.type, _this.param.objid);
          } else {
            mapalert(res.msg);
          }
        })
        .catch((err) => {
          mapalert("定位类型不存在!");
        });
    },
    resize() {
      var _this = this;
      setTimeout(function () {
        _this.map.updateSize();
      }, 200);
    },
  },

  // watch: {
  //   param(val) {
  //     actLocate(this.map, val.type, val.objid);
  //   },
  // },
  directives: {
    // 使用局部注册指令的方式
    resize: {
      // 指令的名称
      bind(el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        let width = "",
          height = "";
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value(); // 关键
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      },
    },
  },
};
</script>

<style scoped>
#locatemap {
  width: 100%;
  height: 100%;
}
</style>